import AutocompleteItem from './AutocompleteItem';
import { generateUrlForCategory } from '../../_helpers/search-bar-urls';
import { getResultCategoryDataLinkEvent } from '../../_helpers/search-bar-data-link-events';
import { Autocomplete, CategorySearchConfig } from '../../SearchBarProps';
import { useComponentContext } from '../../../_helpers/componentContext.tsx';

type AutocompleteCategoryProps = {
	searchInput: string;
	resultsByCategory: Autocomplete[];
	category: string;
	categoryConfig: CategorySearchConfig;
	seeAllLabel: string;
	selectedId: string;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const AutocompleteCategory: React.FC<AutocompleteCategoryProps> = ({
	searchInput,
	resultsByCategory,
	category,
	categoryConfig,
	seeAllLabel,
	selectedId,
}) => {
	const componentName = useComponentContext().componentName;
	return (
		!!resultsByCategory.length && (
			<>
				<li className="autocomplete-category" data-category={category}>
					{categoryConfig.label}
					<a
						className="autocomplete-item-wrapper"
						tabIndex={-1}
						href={generateUrlForCategory(categoryConfig, searchInput)}
						aria-label={`view-all:${categoryConfig.label}`}
						data-link-event={getResultCategoryDataLinkEvent(
							componentName,
							searchInput,
							categoryConfig
						)}
						data-final-url
					>
						{seeAllLabel}
					</a>
				</li>

				{resultsByCategory.map((result) => (
					<AutocompleteItem
						key={result.id}
						result={result}
						searchInput={searchInput}
						selected={selectedId === result.id}
					/>
				))}
			</>
		)
	);
};

export default AutocompleteCategory;
